/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type OpsTeamAutomationType from '@jira/spa-apps__ops-team-scope-automation/src/ExportedDefault.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyOpsTeamAutomation: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof OpsTeamAutomationType>(
	() =>
		import(
			/* webpackChunkName: "async-ops-team-scope-automation", jiraSpaEntry: "async-ops-team-scope-automation" */ '@jira/spa-apps__ops-team-scope-automation/src/ExportedDefault.tsx'
		),
);

const AsyncOpsTeamAutomation = (): React.JSX.Element => (
	<LazyPage Page={LazyOpsTeamAutomation} pageId="ops-team-automation" shouldShowSpinner />
);

export default AsyncOpsTeamAutomation;
